import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-db3bb0e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "h5 mb-1 mt-1" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = {
  key: 0,
  class: "table table-sm table-borderless"
}
const _hoisted_6 = { width: "20%" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  class: "btn-group",
  role: "group",
  "aria-label": "Extra info"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-sm-12" }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-sm-12" }
const _hoisted_15 = { key: 2 }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-sm-12" }
const _hoisted_18 = ["value"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { width: "10%" }, null, -1))
const _hoisted_20 = { width: "30%" }
const _hoisted_21 = {
  key: 0,
  class: "row"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-2 promptcontainer" }, "Notes:", -1))
const _hoisted_23 = {
  class: "col-sm-10",
  style: {"padding-left":"0px"}
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { width: "10%" }, null, -1))
const _hoisted_25 = { width: "30%" }
const _hoisted_26 = {
  key: 0,
  class: ""
}

import { computed, inject, ref, watch } from 'vue';
import { useStore } from 'vuex';
import _get from 'lodash/get';
import { Compliancequestion, Complianceitem, Report } from '@/models';
import ContentEditable from '@/components/ContentEditable.vue';
import Photos from '@/components/photo/Photos.vue';
import { useToast } from "vue-toastification";
import { photoSrc } from '@/utilities';


export default /*#__PURE__*/_defineComponent({
  __name: 'ComplianceItem',
  props: {
    complianceitem: {},
    index: {}
  },
  setup(__props: any) {

const props = __props;

const store = useStore();
const toasted = useToast();
const sectionIndex = inject<number>('sectionIndex');
const actProperty: any = inject('actProperty');

const report = computed(() => store.getters['reports/current'] as Report);
const compliancelist = computed(() => store.getters['customerdictionary/compliancelist'] as Compliancequestion[]);

const setReportDeep = (payload: { path: string; data: any }): Promise<void> => store.dispatch('reports/setReportDeep', payload);

//const complianceitem = ref(props.complianceitem);
//const index = ref(props.index);

const getValueEditableKey = () => {
  return props.complianceitem.slug + props.complianceitem.value;
};

const compliancequestion = computed(() => {
  let question = null;
  if (compliancelist.value && props.complianceitem) {
    question = compliancelist.value.find(
      (q) => q.slug === props.complianceitem.slug
    );
  }
  return question;
});

const linkcompliancequestion = computed(() => {
  let question = null;
  if (compliancequestion.value?.link) {
    question = compliancelist.value.find(
      (q) => q.slug === compliancequestion.value?.link
    );
  }
  return question;
});

const optionlist = computed(() => {
  let list: string[] = [];
  if (compliancequestion.value?.optionList) {
    list = compliancequestion.value.optionList.filter((o) => o);
  }
  return list;
});

const setValue = (value: string) => {
  setReportDeep({ path: getItemPath("value"), data: value });
};


const getPhotos = () => {
  return _get(props.complianceitem, "photos", []);
};

const photoscount = computed(() => {
  const photos = _get(props.complianceitem, "photos", []);
  return photos.length;
});

const linkCheck = () => {
  let display = true;
  if (linkcompliancequestion.value) {
    if (report.value && report.value.compliancesections && sectionIndex !== undefined) {
      let section = report.value.compliancesections[sectionIndex];
      if (section && section.complianceitems) {
        let linkeditem = section.complianceitems.find(
          (ci) => ci.slug === linkcompliancequestion.value?.slug
        );
        if (
          linkeditem &&
          linkeditem.value &&
          linkeditem.value === compliancequestion.value?.linkconditionvalue
        ) {
          display = true;
        } else {
          display = false;
        }
      }
    }
  }
  return display;
};

const getItemPath = (append: string) => {
  return `compliancesections[${sectionIndex}].complianceitems[${props.index}]${append ? `.${append}` : ''}`;
};


return (_ctx: any,_cache: any) => {
  return (linkCheck())
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "card bg-white",
        id: `item-${_ctx.complianceitem._uuid}`
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h4", _hoisted_3, _toDisplayString(_ctx.complianceitem.prompt), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          (compliancequestion.value)
            ? (_openBlock(), _createElementBlock("table", _hoisted_5, [
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_6, [
                      (compliancequestion.value.questionType == 'select')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionlist.value, (option) => {
                                return (_openBlock(), _createElementBlock("button", {
                                  key: option,
                                  class: _normalizeClass(["btn btn-light", {
                      buttonselected: _ctx.complianceitem.value == option,
                    }]),
                                  onClick: ($event: any) => (setValue(option))
                                }, _toDisplayString(option), 11, _hoisted_9))
                              }), 128))
                            ]),
                            _createElementVNode("div", _hoisted_10, [
                              _createElementVNode("div", _hoisted_11, [
                                (_openBlock(), _createBlock(ContentEditable, {
                                  key: getValueEditableKey(),
                                  content: _ctx.complianceitem.value,
                                  onUpdate: _cache[0] || (_cache[0] = ($event: any) => (setValue($event)))
                                }, null, 8, ["content"]))
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (compliancequestion.value.questionType == 'text')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            _createElementVNode("div", _hoisted_13, [
                              _createElementVNode("div", _hoisted_14, [
                                (_openBlock(), _createBlock(ContentEditable, {
                                  key: getValueEditableKey(),
                                  content: _ctx.complianceitem.value,
                                  onUpdate: _cache[1] || (_cache[1] = ($event: any) => (setValue($event)))
                                }, null, 8, ["content"]))
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (compliancequestion.value.questionType == 'textarea')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _createElementVNode("div", _hoisted_16, [
                              _createElementVNode("div", _hoisted_17, [
                                _createElementVNode("textarea", {
                                  class: "form-control textarea",
                                  rows: "3",
                                  value: _ctx.complianceitem.value,
                                  onUpdate: _cache[2] || (_cache[2] = ($event: any) => (setValue($event)))
                                }, null, 40, _hoisted_18)
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _hoisted_19,
                    _createElementVNode("td", _hoisted_20, [
                      (compliancequestion.value.notes)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                            _hoisted_22,
                            _createElementVNode("div", _hoisted_23, [
                              _createVNode(ContentEditable, {
                                content: _ctx.complianceitem.notes,
                                onUpdate: _cache[3] || (_cache[3] = ($event: any) => (
                      setReportDeep({
                        path: getItemPath('notes'),
                        data: $event,
                      })
                    ))
                              }, null, 8, ["content"])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _hoisted_24,
                    _createElementVNode("td", _hoisted_25, [
                      (compliancequestion.value.photo == true)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                            (_openBlock(), _createBlock(Photos, {
                              key: `${photoscount.value}`,
                              photos: getPhotos(),
                              path: getItemPath('photos')
                            }, null, 8, ["photos", "path"]))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ], 8, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})